<div class="{{fromQuickCall ? 'row pl-0' :'row col-12 col-xl-12 col-lg-12 col-md-12 col-sm-12 pl-0'}}">
    <div *ngFor="let customField of customFields" 
    class="{{fromQuickCall ? 'col-xl-12 col-lg-12 col-md-12 col-sm-12 col-12' : 'col-xl-6 col-lg-6 col-md-12 col-sm-12 col-12 sd_custom_field'}}">    

            <!-- String Custom Field -->
    <zsd-stringfield *ngIf="customField.dataType === DATATYPE_STRING"
    [customField]="customField"
    [parentForm]="parentForm"
    [fromQuickCall]="fromQuickCall"
    ></zsd-stringfield>


    <!-- Number Custom Field -->
    <zsd-numberfield *ngIf="customField.dataType === DATATYPE_NUMBER"
    [clientEditable]="customField.clientEditable"
    [dscEnable]="customField.dscEnable"
    [description]="customField.description" 
    [displayName]="customField.displayName"
    [fieldId]="customField.fieldId"
    [required]="customField.required"
    [fieldType]="customField.fieldType"
    [defaultValue]="customField.defaultValue"
    [valueType]="customField.valueType"
    [parentForm]="parentForm"
    [fromQuickCall]="fromQuickCall"
    ></zsd-numberfield>


    <!-- Date Custom Field -->
    <zsd-datefield *ngIf="customField.dataType === DATATYPE_DATE" 
    [clientEditable]="customField.clientEditable"
    [dscEnable]="customField.dscEnable"
    [description]="customField.description" 
    [displayName]="customField.displayName"
    [fieldId]="customField.fieldId"
    [required]="customField.required"
    [valueType]="customField.valueType"
    [defaultValue]="customField.defaultValue"
    [dateFormat]="customField.dateFormat"
    [parentForm]="parentForm"
    [fromQuickCall]="fromQuickCall"
    [id]="id"
    ></zsd-datefield>

    <!-- Boolean Custom Field -->
    <zsd-booleanfield *ngIf="customField.dataType === DATATYPE_BOOLEAN"
    [clientEditable]="customField.clientEditable"
    [dscEnable]="customField.dscEnable"
    [description]="customField.description" 
    [displayName]="customField.displayName"
    [fieldId]="customField.fieldId"
    [required]="customField.required"
    [fieldType]="customField.fieldType"
    [defaultValue]="customField.defaultValue"
    [valueType]="customField.valueType"
    [parentForm]="parentForm"
    [fromQuickCall]="fromQuickCall"
    ></zsd-booleanfield>


    <!-- Currency Custom Field -->
    <zsd-currencyfield *ngIf="customField.dataType === DATATYPE_CURRENCY"
    [customField]="customField"
    [parentForm]="parentForm"
    [fromQuickCall]="fromQuickCall"
    ></zsd-currencyfield>


    <!-- Hyperlink Custom Field -->
    <zsd-hyperlinkfield *ngIf="customField.dataType === DATATYPE_HYPERLINK"
    [customField]="customField"
    [parentForm]="parentForm"
    [fromQuickCall]="fromQuickCall"
    ></zsd-hyperlinkfield>
</div>
</div>
